<template>
  <div id="app" class="fade-in">
    <app-animation-controller/>
    <!-- gradient backdrop -->
    <div class="container-fluid u-bg-gradientBlue" style="padding-bottom: 100px">
      <!-- navbar -->
      <div class="container-fluid Navbar-container" :class="menuClass">
        <nav class="container">
          <div class="row Navbar">
            <!-- hamburger menu -->
            <div class="col-6">
              <div
                class="Hamburger"
                @click="menuIsOpen = !menuIsOpen"
              >
                <div class="Hamburger-bar" :class="menuClass"></div>
                <div class="Hamburger-bar" :class="menuClass"></div>
                <div class="Hamburger-bar" :class="menuClass"></div>
              </div>
            </div>
            <div class="col-6 d-flex flex-column justify-content-center text-right">
              <a href="http://ideum.com/" target="_blank" rel="noopener">
                <app-logo-ideum
                  :width="'80px'"
                  :height="'100%'"
                />
              </a>
              </div>
          </div>
          <!-- navigation menu -->
          <div class="row Menu" :class="menuClass">
            <div class="col-12">
              <ul class="Menu-list">
                <li class="Menu-list-item" @click="jumpToSection('#app')">Platform</li>
                <li class="Menu-list-item" @click="jumpToSection('#performance')">Performance</li>
                <li class="Menu-list-item" @click="jumpToSection('#durability')">Durability</li>
                <li class="Menu-list-item" @click="jumpToSection('#software')">Software</li>
                <li class="Menu-list-item" @click="jumpToSection('#contact')">Contact</li>
              </ul>
            </div>
          </div>
        </nav>
      </div>
      <!-- end navbar -->

      <!-- main content -->
      <main class="container MainContent" :class="{ 'is-shifted': menuIsOpen }">
        <!-- hero section -->
        <div class="row position-relative">
          <!-- graphic circle -->
          <div class="Circle Circle--01"></div>
          <!-- hero content - text -->
          <div class="col-xl-4 col-md-5 offset-md-1">
            <h1 class="Title u-textShadow">
              Platform Multitouch
            </h1>
            <p class="Subtitle mt-2 mt-md-4 u-textShadow">
              The Platform Multitouch Table with 3M™ touch technology and an LG commercial display sets the standard for interactive touch tables. This popular model is available with a 43”, 49”, 55”, or 65” interactive surface.
            </p>
          </div>
          <!-- hero content - image -->
          <div class="col-lg-8 col-md-8 pt-3 Hero-imgWrapper">
            <img :src="'./static/images/ideum-platform-03--shadow--1000.png'" alt="" class="Hero-img">
          </div>
        </div>
        <!-- end hero section -->

        <!-- 3M article row -->
        <div class="row Article-wrapper--3M">
          <div class="col-xl-4 col-md-6 offset-lg-2 Article">
            <div class="Circle Circle--filled Circle--02"></div>
            <div class="Dots-wrapper Dots-wrapper--01">
              <ul class="Dots-list">
                <li class="Dots-list-dot Dots-list-dot--vertical"></li>
                <li class="Dots-list-dot Dots-list-dot--vertical"></li>
                <li class="Dots-list-dot Dots-list-dot--vertical"></li>
                <li class="Dots-list-dot Dots-list-dot--vertical"></li>
                <li class="Dots-list-dot Dots-list-dot--vertical"></li>
                <li class="Dots-list-dot Dots-list-dot--vertical"></li>
                <li class="Dots-list-dot Dots-list-dot--vertical"></li>
                <li class="Dots-list-dot Dots-list-dot--vertical"></li>
                <li class="Dots-list-dot Dots-list-dot--vertical"></li>
                <li class="Dots-list-dot Dots-list-dot--vertical"></li>
                <li class="Dots-list-dot Dots-list-dot--vertical"></li>
              </ul>
            </div>
            <h2 class="Article-title u-textShadow">3M™ Touch</h2>
            <p class="Article-subtitle u-textShadow">The Platform comes with 3M™ projected capacitive (pcap) touch.</p>
            <ul class="Article-list">
              <li class="Article-list-item">80 simultaneous touch points</li>
              <li class="Article-list-item">Supports many leading active pens and conductive styli</li>
              <li class="Article-list-item">Palm rejection</li>
              <li class="Article-list-item">&lt;10 ms response time</li>
              <li class="Article-list-item">Bezel-free, glass-to-edge design</li>
              <li class="Article-list-item">Anti-glass and anti-stiction surface</li>
            </ul>
          </div>
          <div class="col-lg-3 col-md-4 offset-md-1 d-none d-md-flex justify-content-center justify-content-xl-end flex-column">
            <app-logo3m/>
          </div>
        </div>
        <!-- end 3M article row -->

        <!-- performance section-->
        <div id="performance" class="row position-relative mt-5 pt-5 pb-xl-5 Article-wrapper">
          <div class="Circle Circle--03"></div>
          <div class="Dots-wrapper Dots-wrapper--02">
              <ul class="Dots-list">
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
              </ul>
            </div>
          <div class="col-md-7 d-flex flex-column justify-content-center d-lg-block mt-md-5 pt-md-5 offset-xl-1">
            <img
              :data-src="'./static/images/ideum-platform-02--shadow--1000.png'"
              class="lazyload"
              alt="Ideum Platform Multitouch Table">
          </div>
          <div class="col-xl-3 col-lg-4 col-md-5 mt-xl-5 pt-xl-5 mt-3 pt-3 mr-auto Article Article--right">
            <h2 class="Article-title u-textShadow">Intel &amp; NVIDIA</h2>
            <p class="Article-subtitle pb-5 u-textShadow">Ideum touch systems use powerful Intel processors and NVIDIA graphics cards perfect for any Windows application.</p>
          <ul class="Article-list mt-xl-5 pt-xl-5">
            <li class="Article-list-item Article-list-item--right">
              Intel Core i7-6700K 4.2GHz processor</li>
            <li class="Article-list-item Article-list-item--right">
              GTX 1070 NVIDIA graphics card or GTX 1080
            </li>
            <li class="Article-list-item Article-list-item--right">
              Micron M600 512GB SSD</li>
            <li class="Article-list-item Article-list-item--right"
              >16GB DDR4 RAM or 32GB RAM
            </li>
          </ul>
          </div>
        </div>
        <!-- end performance section -->

        <!-- specs article row -->
        <div class="row position-relative mt-5 py-5 px-sm-5 px-lg-0 Article-wrapper Article-wrapper--dark">
          <div class="Circle Circle--04"></div>
          <div class="col-xl-4 col-lg-5 col-md-6 offset-lg-1 Article">
            <h2 class="Article-title">Connectivity</h2>
            <p class="Article-subtitle">The Platform can be connected in a variety of different ways and be locked down for public spaces.</p>
            <ul class="Article-list mt-5">
              <li class="Article-list-item">
                WiFi 802.11 a/b/g/n, Ethernet, Bluetooth 4.0, RFID
              </li>
              <li class="Article-list-item">
                Direct access via USB ports (in lockable enclosure)
              </li>
              <li class="Article-list-item">
                Wireless keyboard with integrated trackpad
              </li>
              <li class="Article-list-item">
                Audio output via ⅛” audio jack (Two 10W speakers are integrated)
              </li>
              <li class="Article-list-item">
                HDMI Output (PC)
              </li>
            </ul>
          </div>
          <!-- end left article -->

          <!-- right article -->
          <div class="col-xl-6 col-lg-5 col-md-6 mr-auto Article Article--right">
            <h2 class="Article-title">LG Display</h2>
            <p class="Article-subtitle">All Ideum models use LG commercial displays.</p>
            <ul class="Article-list mt-5">
              <li class="Article-list-item Article-list-item--right">
                Ultra HD 4K (3840x2160) Resolution at 60hz
              </li>
              <li class="Article-list-item Article-list-item--right">
                Rated for 24/7 operation
              </li>
              <li class="Article-list-item Article-list-item--right">
                Bright 400 to 700 nits display
              </li>
              <li class="Article-list-item Article-list-item--right">
                Contrast ratio 1100:1
              </li>
            </ul>
          </div>
          <!-- end left article -->
        </div>
        <!-- end specs article row -->

        <!-- durability section -->
        <div id="durability" class="row position-relative mt-5 Article-wrapper">
          <div class="Circle Circle--05"></div>
          <div class="Dots-wrapper Dots-wrapper--03">
              <ul class="Dots-list">
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
                <li class="Dots-list-dot Dots-list-dot--horizontal"></li>
              </ul>
            </div>
          <div class="col-md-5 col-xl-3 offset-xl-1 my-md-5 py-5 Article">
            <h2 class="Article-title">Aluminum Case</h2>
            <p class="Article-subtitle pb-5">The Platform and all Ideum products are designed and built in the USA with aircraft-grade aluminum.</p>
            <ul class="Article-list mt-xl-5 pt-lg-2 pt-xl-5">
              <li class="Article-list-item">
                Patent-pending, all-aluminum display case
              </li>
              <li class="Article-list-item">
                Water and vandal-resistant design
              </li>
              <li class="Article-list-item">
                Custom locking enclosure
              </li>
              <li class="Article-list-item">
                Single push-button power
              </li>
              <li class="Article-list-item">
                Standard black powder-coat (custom colors available)
              </li>
            </ul>
          </div>
          <div class="col d-flex flex-column justify-content-center">
            <img
              :data-src="'./static/images/ideum-platform-01--shadow--1000.png'"
              class="lazyload"
              alt="Ideum Platform Multitouch Table">
          </div>
        </div>
        <!-- end durability section -->

        <!-- software and ecosystem section -->
        <div id="software" class="row Article-wrapper Article-wrapper--dark">
          <div class="col-lg-4 offset-lg-1 my-5 px-md-5 pl-lg-3 pr-lg-5 py-lg-5 Article">
            <h2 class="Article-title">What's Included</h2>
            <p class="Article-subtitle">All of our touch tables include a three year warranty and support.</p>
            <ul class="Article-list">
              <li class="Article-list-item">
                Three year warranty
              </li>
              <li class="Article-list-item">
                Dedicated support and ticketing
              </li>
              <li class="Article-list-item">
                Support for the <a href="http://tangibleengine.com/" class="Link Link--inline" target="_blank" rel="noopener">Tangible Engine</a> object recognition SDK, designed to work exclusively on <a href="https://www.ideum.com/products/touch-tables" class="Link Link--inline" target="_blank" rel="noopener">Ideum Touch Tables</a>.
              </li>
              <li class="Article-list-item">
                Free lifetime license of <a href="http://gestureworks.com/" target="_blank" class="Link--inline" rel="noopener">GestureWorks 2 software</a>
              </li>
            </ul>
          </div>
            <div class="col Article-image-wrapper lazyload"
            :data-bg="'./static/images/ideum-tangibleEngine-01--1000.jpg'">
            <a href="http://tangibleengine.com/" class="Link Link--block" target="_blank" title="Tangible Engine Media Creator" rel="noopener"></a>
          </div>
        </div>
        <!-- end software and ecosystem section -->

      </main>
      <!-- end main content -->
    </div>
    <!-- end gradient backdrop -->

    <!-- call-to-action section -->
    <div class="container-fluid u-bg-white">
      <div class="container">
        <div class="row my-5">
          <div class="col-md-8 col-lg-6 offset-lg-1 CTA">
            <h3 class="mb-3 CTA-heading u-color-navy">Ready to Take the Next Step?</h3>
            <p class="u-color-blueGrey">Learn more about the Ideum Platform and download the latest specifications (PDF).</p>
            <p class="mb-4 u-color-lightBlue">Ideum sells the Platform multitouch table direct, worldwide. You can also rent the Platform multitouch table in the US for events or trade shows.</p>
          </div>
          <div class="col-6 col-md-3 col-lg-2 mx-auto ml-md-auto mr-lg-auto d-flex flex-md-column justify-content-center">
            <a href="https://cookieless-offload.s3-us-west-2.amazonaws.com/downloadables/Ideum-Specs-Platform.pdf" target="_blank"><button class="Button">Download</button></a>
          </div>
        </div>
      </div>
    </div>
    <!-- end call-to-action section -->

    <!-- footer / contact section -->
    <footer id="contact" class="container-fluid Footer py-5 u-bg-darkGrey">
      <div class="container">
        <div class="row">
          <div class="col-md-4 col-lg-3 offset-lg-1 text-center text-md-left">
            <a href="http://ideum.com/" target="_blank" rel="noopener">
              <app-logo-ideum
                :width="'120px'"
              />
            </a>
            <p class="pt-3 pl-2">&copy; Ideum 2017. All rights reserved.</p>
          </div>
          <div class="col-md-4 col-lg-4 my-5 my-md-0 text-center text-md-left">
            <p>Call Ideum sales at: <a href="tel:1-505-792-1110" class="Link--inline">(505) 792-1110</a></p>
            <p>Call toll free in the US and Canada: <a href="tel:1-855-898-6824" class="Link--inline">(855) 898-6824</a></p>
            <p>Email us at: <a href="mailto:sales@ideum.com" target="_blank" class="Link--inline">sales@ideum.com</a> or visit our <a href="https://ideum.com/contact" target="_blank" class="Link--inline" rel="noopener">online inquiry form.</a></p>
          </div>
          <div class="col-md-4 col-lg-3 col-xl-2 offset-lg-1 text-center text-md-left">
            <h4>Follow Us</h4>
            <ul class="SocialList">
              <li class="SocialList-item">
                <a href="https://twitter.com/ideum?lang=en" target="_blank" title="Ideum on Twitter" rel="noopener">
                  <icon name="twitter" scale="1.5"/>
                </a>
              </li>
              <li class="SocialList-item">
                <a href="https://www.facebook.com/ideum/" target="_blank" title="Ideum on Facebook" rel="noopener">
                  <icon name="facebook" scale="1.5"/>
                </a>
              </li>
              <li class="SocialList-item">
                <a href="https://www.linkedin.com/company/ideum/" target="_blank" title="Ideum on LinkedIn" rel="noopener">
                  <icon name="linkedin" scale="1.5"/>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
    <!-- end footer / contact section -->

  </div>
</template>

<script>
import Icon from 'vue-awesome/components/Icon'
import 'vue-awesome/icons/twitter'
import 'vue-awesome/icons/facebook'
import 'vue-awesome/icons/linkedin'

import appAnimationController from './components/Animation-controller'
import appLogo3m from './components/Logo-3M'
import appLogoIdeum from './components/Logo-ideum'

import jump from 'jump.js'

require('lazysizes')

export default {
  name: 'app',

  components: {
    appAnimationController,
    appLogo3m,
    appLogoIdeum,
    Icon
  },

  data () {
    return {
      menuIsOpen: null,
      scrollIsHome: true
    }
  },

  computed: {
    menuClass () {
      return {
        'is-open': this.menuIsOpen,
        'is-closed': !this.menuIsOpen,
        'is-opaque': !this.scrollIsHome
      }
    }
  },

  methods: {
    checkScrollPos () {
      const scrollY = window.scrollY || window.pageYOffset
      scrollY <= 0 ? this.scrollIsHome = true : this.scrollIsHome = false
    },

    jumpToSection (selector) {
      jump(selector, {
        offset: -110
      })
    }
  },

  created () {
    // add simple support for background images:
    document.addEventListener('lazybeforeunveil', e => {
      const bg = e.target.getAttribute('data-bg')
      if (bg) {
        e.target.style.backgroundImage = 'url(' + bg + ')'
      }
    })
  },

  mounted () {
    window.addEventListener('scroll', this.checkScrollPos)
  }
}
</script>

<style lang="scss" scoped>
@import './assets/styles/_variables.scss';

body {
  margin: 0;
}

#app {
  overflow-x: hidden;
}

.Article-wrapper--3M {
  @media screen and (min-width: $grid-md) {
    margin-top: 4rem;
  }
  @media screen and (min-width: $grid-lg) {
    margin-top: 7rem;
  }
  @media screen and (min-width: $grid-xl) {
    margin-top: 14rem;
  }
}

.Article-wrapper--dark {
  background-color: rgba(29, 29, 29, .57);
}

.Article {
  color: $colorWhite;
}

.Article--right {
  text-align: right;
}

.Article-image-wrapper {
  background-position: center;
  height: 50vh;
  @media screen and (min-width: $grid-lg) {
    height: auto;
  }
}

.Article-title {
  font-size: 2rem;
  display: inline-block;
  letter-spacing: .05em;
  margin-bottom: 1.75em;
  position: relative;
  &::after {
    background-color: $colorTeal;
    content: '';
    position: absolute;
    bottom: -.75em;
    left: 0;
    width: 100%;
    height: 2px;
  }
}

.Article-subtitle {
  font-size: 1.1rem;
  font-weight: 200;
  line-height: 2em;
  margin-bottom: 2em;
}

.Article-list {
  font-size: 1.1rem;
  font-weight: 200;
  // line-height: 2em;
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.Article-list-item {
  margin: 0 0 .5em 1.5em;
  position: relative;
  &::after {
    border: 2px solid $colorTeal;
    border-radius: 50%;
    content: '';
    position: absolute;
    top: .5em;
    left: -1.5em;
    width: 10px;
    height: 10px;
  }
}

.Article-list-item--right {
  margin: 0 1.5em .5em 0;
  &::after {
    left: auto;
    right: -1.5em;
  }
}

.Button {
  background: $gradientTeal;
  border: 2px solid transparent;
  border-radius: 50px;
  color: $colorWhite;
  font-family: 'Lato', sans-serif;
  cursor: pointer;
  max-width: 180px;
  outline: none;
  padding: .5em 2em;
  transition: $transitionDefault;
  &:hover {
    border: 2px solid $colorLightBlue;
  }
}

.Circle {
  border: 4px solid $colorWhite;
  border-radius: 50%;
  opacity: .05;
  position: absolute;
}

.Circle--filled {
  background-color: $colorTeal;
}

.Circle--01 {
  top: 0;
  right: 10%;
  width: 618px;
  height: 618px;
}

.Circle--02 {
  top: -38%;
  left: -19%;
  width: 660px;
  height: 660px;
}

.Circle--03 {
  top: -8%;
  left: -33%;
  width: 1200px;
  height: 1200px;
}

.Circle--04 {
  left: -5%;
  bottom: -26%;
  width: 600px;
  height: 600px;
}

.Circle--05 {
  right: 7%;
  bottom: 0;
  width: 750px;
  height: 750px;
}

.CTA {
  font-size: 1.2rem;
  line-height: 2em;
}

.CTA-heading {
  font-size: 1.8rem;
  letter-spacing: .02em;
}

.Dots-wrapper {
  display: none;
  @media screen and (min-width: $grid-md) {
    display: block;
  }
  position: absolute;
  z-index: 1;
}

.Dots-wrapper--01 {
  top: 0;
  left: -25%;
}

.Dots-wrapper--02 {
  top: 56%;
  left: 24%;
  transform: rotate(180deg);
  @media screen and (min-width: $grid-xl) {
    top: 49%;
    left: 36%;
  }
}

.Dots-wrapper--03 {
  top: 47%;
  left: 7%;
  @media screen and (min-width: $grid-xl) {
    top: 42%;
    left: 29%;
  }
}

.Dots-list {
  list-style-type: none;
}

.Dots-list-dot {
  background-color: $colorWhite;
  border-radius: 100%;
  opacity: 0;
  transition: $transitionSnappy;
  width: 7px;
  height: 7px;
}

.Dots-list-dot--horizontal {
  display: inline-block;
  margin: 0 21px 0 0;
}

.Dots-list-dot--vertical {
  margin: 0 0 21px 0;
}

.Footer {
  color: $colorWhite;
}

.Hamburger {
  cursor: pointer;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 40px;
  height: 100%;
}

.Hamburger-bar {
  background-color: $colorWhite;
  margin-bottom: 6px;
  width: 40px;
  height: 4px;
  transition: $transitionSnappy;
  &.is-open:first-child {
    transform: rotate(45deg) translateY(14px);
  }
  &.is-open:nth-child(2) {
    opacity: 0;
  }
  &.is-open:last-child {
    transform: rotate(-45deg) translateY(-14px);
  }
  &.is-closed:first-child {
    transform: rotate(0) translate(0);
  }
  &.is-closed:nth-child(2) {
    opacity: 1;
  }
  &.is-closed:last-child {
    transform: rotate(0) translate(0);
  }
}

.Hero-imgWrapper {
  z-index: 2;
  @media screen and (min-width: $grid-md) {
    position: absolute;
    top: 17%;
    right: 0;
  }
  @media screen and (min-width: $grid-lg) {
    top: 10%;
  }
}

.Hero-img {
  width: 100%;
}

.Link {
  cursor: pointer;
}

.Link--block {
  display: block;
  width: 100%;
  height: 100%;
}

.Link--inline {
  color: inherit;
  position: relative;
  white-space: nowrap;
  z-index: 1;
  &::before {
    background-color: $colorTeal;
    content: '';
    position: absolute;
    left: 0;
    bottom: -3px;
    transition: $transitionDefault;
    width: 100%;
    height: 2px;
    z-index: -1;
  }
  &:hover::before {
    height: 6px;
  }
}

.MainContent {
  padding-top: 140px;
  transition: $transitionSnappy;
  &.is-shifted {
    padding-top: 300px;
  }
}

.Menu {
  transition: $transitionSnappy;
  &.is-closed {
    display: none;
    opacity: 0;
    height: 0;
  }
  &.is-open {
    opacity: 1;
    padding: 0 0 30px 0;
    @media screen and (min-width: $grid-sm) {
      padding: 40px 0;
    }
  }
}

.Menu-list {
  display: inline-block;
  justify-content: space-around;
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  @media screen and (min-width: $grid-sm) {
    display: inline-flex;
    margin-right: 3em;
  }
}

.Menu-list-item {
  color: $colorWhite;
  cursor: pointer;
  font-family: 'Teko', sans-serif;
  font-size: 1.33rem;
  letter-spacing: .1em;
  text-align: center;
  text-transform: uppercase;
  transition: $transitionDefault;
  @media screen and (min-width: $grid-sm) {
    font-size: 1.25rem;
    text-align: left;
    &:hover {
      color: $colorTeal;
    }
  }
}

.Navbar-container {
  position: fixed;
  left: 0;
  right: 0;
  transition: $transitionSnappy;
  z-index: 10;
  &.is-opaque {
    background-color: rgba(95, 154, 202, .75);
  }
  &.is-open {
    background-color: $colorNavy;
    border-bottom: 2px solid $colorTeal;
  }
}

.Navbar {
  height: 80px;
}

.SocialList {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.SocialList-item {
  display: inline-block;
  padding-right: 2em;
  &:last-child {
    padding-right: 0;
  }
  &:hover a {
    color: $colorTeal;
  }
}

.Subtitle {
  color: $colorWhite;
  font-size: 1rem;
  font-weight: 200;
  line-height: 2em;
  @media screen and (min-width: $grid-lg) {
    font-size: 1.25rem;
  }
}

.Title {
  color: $colorWhite;
  font-size: 3rem;
  line-height: 1em;
  @media screen and (min-width: $grid-lg) {
    font-size: 5rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue